import { axiosInstance } from "../../utils/axios";
import { PerformanceLogItem } from "../../pages/infos/troubleshooting/tools/performance-logs/performance-logs.types";

/**
 * Retrieve the performance (elaboration) logs for the current tenant.
 *
 * @param allUsers `false` (default) returns only the authenticated user's
 *                 records; `true` returns all tenant records.
 */
export async function getPerformanceLogs(allUsers: boolean): Promise<PerformanceLogItem[]> {
  const resp = await axiosInstance.get("/api/performance-logs", { params: { allUsers } });
  return resp.data;
}
